import {
  doc as docMobile,
  FirebaseFirestoreTypes,
  onSnapshot as onSnapshotMobile
} from '@react-native-firebase/firestore';
import { Stack, useLocalSearchParams } from 'expo-router';
import { doc, DocumentData, Firestore, onSnapshot } from 'firebase/firestore';
import { useEffect, useLayoutEffect, useState } from 'react';
import { Platform, StyleSheet, View } from 'react-native';
import { SafeAreaView } from 'react-native-safe-area-context';

import { useGetNonProfitInsights } from '@/api/hooks/nonProfitOrgHooks';
import LightRatingButton from '@/components/buttons/LightRatingButton';
import ScreenState from '@/components/npo/onboarding/ScreenState';
import { useAuth } from '@/contexts/authContext';
import { useNpoLoginScreenState } from '@/contexts/npoLoginScreenStateContext';
import { db } from '@/firebaseConfig';

export const NpoOnBoardingLayout = () => {
  const { state } = useAuth();
  const { npoId } = useLocalSearchParams<{
    npoId: string;
  }>();
  const { state: screenState, setTotalPages, setInitialNpoData } = useNpoLoginScreenState();
  const { data, isFetching, refetch, dataUpdatedAt } = useGetNonProfitInsights({
    id: state.signUpData?.loginEmail?.npoId ?? ''
  });

  const [ranking, setRanking] = useState(0);

  useLayoutEffect(() => {
    setTotalPages(14);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [npoId]);

  const onResult = (
    documentSnapshot: FirebaseFirestoreTypes.DocumentSnapshot<FirebaseFirestoreTypes.DocumentData> | DocumentData
  ) => {
    if (documentSnapshot.exists) {
      const rankingScore = documentSnapshot.data() as { score: number };
      setRanking(rankingScore?.score ?? 0);
    }
  };

  const onError = (error: Error) => {
    console.error(error);
  };

  useEffect(() => {
    const npoId = state.signUpData?.loginEmail?.npoId;
    if (!npoId) return;

    if (Platform.OS === 'web') {
      //Web
      const lightRatingSubscriber = onSnapshot(doc(db() as Firestore, 'light_rating', npoId), onResult, onError);

      //Stop listening to lightRating
      return () => lightRatingSubscriber();
    } else {
      // Mobile
      const lightRatingSubscriber = onSnapshotMobile(
        docMobile(db() as FirebaseFirestoreTypes.Module, 'light_rating', npoId),
        onResult,
        onError
      );

      //Stop listening to lightRating
      return () => lightRatingSubscriber();
    }

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [state.signUpData?.loginEmail?.npoId]);

  useEffect(() => {
    if (!isFetching) refetch();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [screenState.currentPage]);

  useEffect(() => {
    if (!isFetching && data) setInitialNpoData(JSON.stringify(data));
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [dataUpdatedAt]);

  return (
    <SafeAreaView style={styles.container}>
      <View style={styles.header}>
        <ScreenState lightRating={ranking} totalPages={screenState.totalPages} currentPage={screenState.currentPage} />
        <LightRatingButton lightRatingValue={ranking} disabled />
      </View>
      <Stack
        screenOptions={{
          animation: 'simple_push',
          headerShown: false
        }}>
        <Stack.Screen name="nineNintyForm" />
        <Stack.Screen name="index" />
        <Stack.Screen name="revenue" />
        <Stack.Screen name="backgroundChecks" />
        <Stack.Screen name="boardDirectors" />
        <Stack.Screen name="pastors" />
        <Stack.Screen name="totalSalaries" />
        <Stack.Screen name="pL" />
        <Stack.Screen name="partyAudit" />
        <Stack.Screen name="impactStudy" />
        <Stack.Screen name="salaries" />
        <Stack.Screen name="landEquipments" />
        <Stack.Screen name="fundraising" />
        <Stack.Screen name="programs" />
        <Stack.Screen name="totalGrantsPrograms" />
        <Stack.Screen name="lightRatingQuestions" />
      </Stack>
    </SafeAreaView>
  );
};

const styles = StyleSheet.create({
  container: {
    flex: 1
  },

  header: {
    flexDirection: 'row',
    width: '100%',
    paddingVertical: 10,
    paddingHorizontal: Platform.OS !== 'web' ? 18 : 0,
    justifyContent: 'space-around',
    alignItems: 'center'
  }
});

export default NpoOnBoardingLayout;
